import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import CustomRoute from "./CustomRoute";
import { SnackbarProvider } from "notistack";
import store from "./services/store";
import { Provider } from "react-redux";
import "./assets/css/bootstrap.min.css";
import "./assets/js/bootstrap.bundle.min.js";
import "./index.css";
import "./helpers/il8n";
import $ from "jquery";

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <StrictMode>
      <SnackbarProvider
        autoHideDuration={3000}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <CustomRoute />
      </SnackbarProvider>
    </StrictMode>
  </Provider>
);
